module.exports = __webpack_public_path__ + "static/img/2.93519d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/Resistance/2.png
// module id = 4zOb
// module chunks = 1